import React from 'react'
import cx from 'classnames'

import Icon, { EIconId } from '../../../../components/icons'

const PromotionBarModal: React.FC<{ onCloseClick: () => void }> = (props) => {
  const [infoOpen, setInfoOpen] = React.useState(false)

  return (
    <div
      className="flex fixed w-full h-full inset-x-0 inset-y-0 z-30 justify-center items-center"
      style={{ backgroundColor: 'rgba(0,0,0,.3)' }}
      onClick={props.onCloseClick}
      data-testid="wrapper"
    >
      <div
        className="flex flex-col relative px-16 py-24 mx-16 bg-white uif-shadow sm:py-32 sm:px-48 sm:uif-max-w-560 md:px-48"
        onClick={(e) => e.stopPropagation()}
      >
        <Icon
          id={EIconId.CLOSE_IN_CIRCLE}
          className="w-32 cursor-pointer absolute right-0 top-0 mr-8 mt-8 sm:mr-16 sm:mt-16"
          onClick={props.onCloseClick}
        />
        <Icon id={EIconId.SALE} className="w-48 mb-32 mx-auto" />
        <p className="text-20 mb-8">Sparen Sie sich die Versandkosten</p>
        <p className="text-winning-green mb-16">Kaufen Sie bis 09.04. um 22.59 Uhr versandkostenfrei bei uns ein.</p>
        <div className="border-t border-b border-lightgrey-light mb-16">
          <div
            className="flex items-center py-16 cursor-pointer"
            onClick={() => setInfoOpen(!infoOpen)}
            data-testid="dialog-trigger"
          >
            <Icon id={EIconId.INFO} className="w-20 mr-8" />
            Bedingungen
            <Icon
              id={EIconId.ANGLE_DOWN}
              className={cx('w-20 ml-auto transition-transform duration-200', {
                'scale-100': !infoOpen,
                '-scale-100': infoOpen,
              })}
            />
          </div>
          <div className={cx({ block: infoOpen, hidden: !infoOpen })} data-testid="dialog-body">
            <p className="mb-16">
              Aktion gilt vom 02.04.2022 um 19:00 Uhr bis 09.04.2022 um 22.59 Uhr für alle Bestellungen.
            </p>
          </div>
        </div>
        <p className="mb-16">Jetzt Wunschprodukte auswählen und bestellen!</p>
        <a
          className="flex items-center justify-center h-48 w-full sm:w-auto px-48 text-white font-bold cursor-pointer bg-brand-orange"
          href="/dpl/c/shop-it-love-it-22-04"
          data-testid="action-button"
        >
          Jetzt shoppen & verlieben
        </a>
      </div>
    </div>
  )
}

export default PromotionBarModal
